@let driverData = driver.driverData;
<onyx-modal
  variant="center"
  heading="{{ driverData | onyxName }} - {{ `${I18N}.heading` | translate }}"
  [close$]="close$"
  (closeModal)="dialogRef.close()"
>
  <onyx-icon headingIcon [name]="driverIcon" [size]="24"></onyx-icon>

  <div class="container">
    <form [formGroup]="form" [onyxAutoFocus]="true">
      @let controls = form.controls;
      <onyx-dropdown
        [formControl]="controls.vehicleUuid"
        label="labels.vehicle"
        [link]="links().vehicle"
        [options]="VEHICLES_SOURCE"
        [optional]="true"
        (selectedOptionValueChange)="vehicle$.next($event.value)"
      ></onyx-dropdown>

      <onyx-dropdown
        [formControl]="controls.trailerUuid"
        [label]="trailerLabel()"
        [link]="links().trailer"
        [options]="TRAILERS_SOURCE"
        (selectedOptionValueChange)="trailer.set($event.value)"
      ></onyx-dropdown>
    </form>

    @if (existingDriver(); as existingDriver) {
      <onyx-message intent="warning">
        <onyx-icon name="alert-circle-two-tone-filled" [size]="20"></onyx-icon>

        <p
          [innerHTML]="
            `${I18N}.driverIsAssigned`
              | translate
                : {
                    vehicle: vehicle$.getValue() | fleetIdentifier,
                    driver: (existingDriver.driverData | onyxName),
                  }
          "
        ></p>

        <p description>
          {{
            `${I18N}.secondDriver`
              | translate: { driver: driverData | onyxName }
          }}
        </p>
      </onyx-message>
    }
  </div>

  <ng-container bottomRightOptions>
    <onyx-button variant="outlined" (click)="close$.next()">
      {{ 'labels.cancel' | translate }}
    </onyx-button>

    <onyx-button
      [disabled]="form.invalid"
      [spinner]="loading()"
      (click)="!loading() ? submit() : null"
    >
      {{ 'labels.save' | translate }}
    </onyx-button>
  </ng-container>
</onyx-modal>
